var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.19999014 1.26205219 5.42518973 2.85037946 7 6 C7.54399285 10.539219 7.62289461 13.9544269 5.25 17.9375 C3 20 3 20 0.875 21 C-1.78145807 22.41677764 -2.12055059 24.21507688 -3 27 C-5.64 27 -8.28 27 -11 27 C-11.3452439 23.28862807 -11.31499373 21.48374038 -9.25 18.3125 C-7.2684147 16.27587066 -5.34649358 14.5922635 -3 13 C-3.33 11.35 -3.66 9.7 -4 8 C-5.98 8.33 -7.96 8.66 -10 9 C-10.33 9.99 -10.66 10.98 -11 12 C-13.64 12 -16.28 12 -19 12 C-19.3125 9.3125 -19.3125 9.3125 -19 6 C-13.36701219 -0.67064345 -8.4066024 -0.82202761 0 0 Z ",
    fill: "#000000",
    transform: "translate(31,5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 2 2 2 2.1875 5.0625 C2 8 2 8 1 9 C-2.4375 9.1875 -2.4375 9.1875 -6 9 C-6.66 8.34 -7.32 7.68 -8 7 C-7.75 3.9375 -7.75 3.9375 -7 1 C-4.48718205 -0.25640898 -2.78302919 -0.20872719 0 0 Z ",
    fill: "#000000",
    transform: "translate(27,36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuee);
export default __webpack_public_path__ + "static/media/quee.0533bc195c4770a2c924c7cc5a090fc0.svg";
export { ForwardRef as ReactComponent };